/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon32Regular = forwardRef('ArrowShapeALeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.56 18.473a3.5 3.5 0 0 1 0-4.95L14.586 2.498C15.846 1.238 18 2.13 18 3.912V9h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8v5.084c0 1.782-2.154 2.675-3.414 1.415L3.56 18.473Zm1.415-3.536a1.5 1.5 0 0 0 0 2.122L16 28.084V22a1 1 0 0 1 1-1h8.998a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8.998a1 1 0 0 1-1-1V3.912L4.974 14.937Z" })));
});
